const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '基本信息',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '归档资料',
    },
  },
  {
    component: 'ZlmNormalDetailList',
    options: {
      data: {},
    },
  },
  // 后端说暂时没有返回这部分数据
  // {
  //     component: 'ZlmTitle',
  //     options: {
  //         size: 'medium',
  //         text: '审核记录',
  //     },
  // },
  // {
  //     component: 'ZlmTabDetail',
  //     options: {
  //         title: '记录',
  //         data: [],
  //     },
  // },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
    }
  },
  methods: {
    getData() {
      this.$request
        .post(
          `/transformToAfter/app/after/bid/queryGuiDang`,
          {
            bdGuid: this.$route.query.id,
          },
          { showLoading: true },
        )
        .then((res) => {
          this.config[1].options.data = {
            标段名称: res.data.bdInfo.bdName,
            标段编号: res.data.bdInfo.bdBH,
            项目名称: res.data.bdInfo.gcName,
            采购编号: '',
            项目类型: getProjectTypeName(res.data.bdInfo.xmLeiXing),
            采购方式: getPurchaseTypeName(res.data.bdInfo.zbFangShi),
            项目经理: res.data.bdInfo.projectManagerName,
            联系电话: res.data.bdInfo.lianXiRenPhone,
          }
          if (res.data.fileVoList && res.data.fileVoList.length > 0) {
            this.config[3].options.data = res.data.fileVoList.map((t) => {
              const obj = {
                归档资料类别: t.shiXiangLeiXingName,
                生成时间: this.$util.timeFormatter(t.createTime),
                //   附件: '',
              }
              this.getFileName(t.fileGuid, obj)
              return obj
            })
          }
        })
    },
    getFileName(guid, target) {
      if (!guid) {
        return ''
      }
      this.$request
        .post(
          '/transformToAfter/guotou-file-business/queryByGroupGuid',
          {
            groupGuid: guid,
          },
          { showLoading: true },
        )
        .then((res) => {
          if (res.data) {
            res.data.forEach((t, index) => {
                console.log(target)
              this.$set(target, `附件${index + 1}`, t.name)
            })
          }
        })
    },
  },
}

module.exports = {
  config,
  mixin,
}
